import {
  RootState,
  setProductMatchConfirmed,
  setSelectedProductId,
} from "@/store";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { useTimeTracking } from "@/contexts/TimeTrackingContext";
import { Radio, Text } from "@mantine/core";
import { ViewMode } from "@/types";
import { ActionStatusBadge } from "./ActionStatusBadge";
import { QaQuestionAction } from "./QaQuestionAction";
import { JobTaskDetailSchema } from "@augmodo/lebron-browser-client";

export const NoMatchCard = ({
  selected,
  mode,
  task,
}: {
  selected?: boolean;
  mode?: ViewMode;
  task?: JobTaskDetailSchema;
}) => {
  const dispatch = useAppDispatch();
  const { recordQ3Interaction } = useTimeTracking();
  const productMatchConfirmed = useAppSelector(
    (state: RootState) => state.oos.productMatchConfirmed,
  );
  return (
    <>
      <div className="flex items-center flex-col justify-center bg-gray-100 p-4 rounded-md h-[100px] mt-2">
        <Text mb="sm">No match found</Text>
        {mode === "viewer" && (
          <Radio
            value="no"
            label="Select"
            checked={productMatchConfirmed === false || selected}
            onChange={() => {
              recordQ3Interaction();
              dispatch(setProductMatchConfirmed(false));
              dispatch(setSelectedProductId(null));
            }}
          />
        )}
      </div>
      {mode !== "viewer" && (
        <ActionStatusBadge
          resultField="product_match_confirmed"
          task={{
            result: { product_match_confirmed: false },
          }}
        />
      )}
      {(mode === "confirmation-qa" || mode === "confirmation-qa-feedback") &&
        task && <QaQuestionAction questionNumber={3} task={task} />}
    </>
  );
};
